import * as React from "react";
import { useMappedState } from "redux-react-hook";

import type { IStore } from "src/core/shared/store";
import { useOrderValidation } from "src/core/orders/hooks/validation";

export const useCurrentOrderValidation = () => {
  const { currentOrder } = useMappedState(({ orders }: IStore) => ({ currentOrder: orders.currentOrder }));

  const {
    canAmendOrder, canSubmitOrder, canSaveOrder, canCancelOrder, isBeforeCutoff
  } = useOrderValidation();

  // returns if the current order can be amended
  const canBeAmended = React.useMemo(() => {
    if (currentOrder.data) {
      return canAmendOrder(currentOrder.data);
    }

    return false;
  }, [ currentOrder.data, canAmendOrder ]);

  // returns if the current order can be saved
  const canBeSaved = React.useMemo(() => {
    if (currentOrder.data) {
      return canSaveOrder(currentOrder.data);
    }

    return false;
  }, [ currentOrder.data, canSaveOrder ]);

  // returns if the current order can be submitted
  const canBeSubmitted = React.useMemo(() => {
    if (currentOrder.data) {
      return canSubmitOrder(currentOrder.data);
    }

    return false;
  }, [ currentOrder.data, canSubmitOrder ]);

  // returns if the current order can be cancelled
  const canBeCancelled = React.useMemo(() => {
    if (currentOrder.data) {
      return canCancelOrder(currentOrder.data);
    }

    return false;
  }, [ currentOrder.data, canCancelOrder ]);

  // returns current order cutoff
  const orderBeforeCutoff = React.useMemo(() => {
    if (currentOrder.data) {
      return isBeforeCutoff(currentOrder.data);
    }

    return false;
  }, [ currentOrder.data, isBeforeCutoff ]);

  return {
    canBeAmended,
    canBeSubmitted,
    canBeSaved,
    canBeCancelled,
    details: { isBeforeCutoff: orderBeforeCutoff }
  };
};
